<template>
<transition name="Introduction">
  <div class="Introduction" :class="{ 'transparent': slugIsIn(['monde', 'monde:1', 'monde:2'])}">

    <!-- <ParticlesVoice /> -->

    <div class="Introduction__container">
      <transition name="Introduction__enki" appear>
        <div ref="enki" class="Introduction__enki">
          <img :src="require('./img/enki.png')" />
        </div>
      </transition>
      <transition name="Introduction__bubble" appear>
        <div :key="$route.params.slug" class="Introduction__bubble" :class="'is-' + $route.params.slug.replace(':', '-')">
          {{ trans('bubbles')[$route.params.slug] }}
        </div>
      </transition>
    </div>

    <transition name="Btn" @enter="enterBtn" @leave="leaveBtn" appear>
      <div @click="next" v-if="trans(btnKey)" :key="$route.params.slug" class="Btn" ref="button" v-html="trans(btnKey)" />
    </transition>

  </div>
</transition>
</template>

<script>
import ParticlesVoice from '@/components/particles/ParticlesVoice'

export default {
  name: 'Introduction',
  components: { ParticlesVoice },
  translations: {
    fr: {
      bubbles: {
        'introduction': 'Allo ? Allo… Oh, tu viens de me réveiller ! Je suis Enki, l’esprit-gardien d’un endroit où sont réunis toutes sortes de visages. Une galerie mystérieuse empreinte de légendes.',
        'introduction:1': 'Une personne a rassemblé plusieurs œuvres d’art ici, mais l’une d’entre elles semble avoir disparu... Que dirais-tu de m’aider à la retrouver ?',
        'merci': '',
        'monde': "Voici le monde tel que les esprits le voient ! Impressionnant, non ?",
        'monde:1': "Ouf, quelle aventure ! Notre quête est maintenant terminée, j'ai bien mérité un peu de repos. Avant de partir, prends le temps d'écouter les commentaires que j'ai glissés près des œuvres.",
        'monde:2': "Et reviens me voir quand tu veux, ma galerie est maintenant la tienne. Bon, c'est l'heure de la sieste…"
      }
    },
    en: {
      bubbles: {
        'introduction': 'Hello? Hello … Oh, you woke me up! I’m Enki, the guardian spirit of a place where there’s a collection of all sorts of faces. A mysterious gallery full of legends.',
        'introduction:1': 'Someone brought lots of artworks here, but one of them seems to have disappeared ... How about helping me find it?',
        'merci': '',
        'monde': " Here’s the world as spirits see it! Remarkable, isn't it?",
        'monde:1': "Oof, what an adventure! Our quest is now completed and I’ve earned a nap. Before you leave, take the time to listen to the comments that I’ve placed near the artworks.",
        'monde:2': "And come back to see me whenever you like: my gallery is now yours. OK, it’s siesta time …",
      }
    },
  },
  computed: {
    btnKey() {
      return this.$route.params.slug == 'introduction:1' ? 'Global.btn.start_experience' : 'Global.btn.continue' }
  },
  beforeDestroy() {
    if(this.$tween)
      this.$tween.kill()
  },
  mounted() {
    TweenMax.from(this.$refs.enki, .75, { scale: .5, opacity: 0, ease: Linear.easeNone, delay: 1 })
    this.$tween = new TimelineMax({ delay: 3, yoyo: true, repeat: -1 })
        .to(this.$refs.enki, 6, { y: 10, ease: Linear.easeNone })
        .to(this.$refs.enki, 8, { y: -10, ease: Linear.easeNone })
        .to(this.$refs.enki, 4, { y: -20, ease: Linear.easeNone })
  },

  methods: {
    enterBtn(el, done) {
      TweenLite.from(el, 1, { delay: 3, alpha: 0, scale: 0, onComplete: done })
    },
    leaveBtn(el, done) {
      TweenLite.to(el, 1, { scale: 0, alpha: 0, onComplete: done })
    },
  },
}
</script>

<style lang="stylus">
@import '~@/config/Settings'
@import '~@/commons/stylus/Media-queries'

.Introduction
  height 100vh
  overflow hidden
  background black
  transition opacity 1s
  position fixed
  width 100vw
  top 0px
  left 0px

  display flex
  align-items center 
  justify-content center
  
  &-enter
  &-leave-active
    opacity 0

  &.transparent
    background transparent

  &__container 
    display flex
    align-items center 
    justify-content flex-start
    width 700px
    position relative

  &__enki   
    width 420px

  bubbleOpacity = .5

  &__bubble

    position absolute
    right 0
    font-size 20px
    line-height 28px
    border-radius 25px 25px 25px 0px
    width 280px
    padding 25px
    background rgba(255,18,117, bubbleOpacity)
    background linear-gradient(30deg, rgba(orange, bubbleOpacity), rgba(blue, bubbleOpacity))
    transition opacity 1s, transform 1s
    transition-delay 1.35s

    &-enter
      opacity 0
      transform translateX(50%)

    &-leave-active
      transform translateY(-50%)
      transition-delay 0s
      opacity 0

    &.is-introduction
    &.is-monde
      background linear-gradient(35deg, rgba(grad_blue, bubbleOpacity) 20%, rgba(grad_blue1, bubbleOpacity) 40%, rgba(grad_green, bubbleOpacity) 60%, rgba(grad_green1, bubbleOpacity) 80%, rgba(grad_yellow, bubbleOpacity) 100%)
      margin-top -20vh

    &.is-introduction-1
    &.is-monde-1
    &.is-monde-2
      background linear-gradient(35deg, rgba(grad_blue, bubbleOpacity) 20%, rgba(grad_blue1, bubbleOpacity) 40%, rgba(grad_green, bubbleOpacity) 60%, rgba(grad_green1, bubbleOpacity) 80%, rgba(grad_yellow, bubbleOpacity) 100%)
      margin-top -20vh

</style>



// WEBPACK FOOTER //
// src/components/introduction/Introduction.vue